export default __webpack_public_path__ + "static/media/No.9-3.1739c0d4.jpg";